export default "<div ng-if=\"$ctrl.value\">\n    <strong>{{::$ctrl.label}}: </strong>{{::$ctrl.value}}\n</div>";